import { Search } from "lucide-react";
import { brl } from "@/lib/api";
import { cn } from "@/lib/utils";
import { GROUPS, TONE, TYPE, elapsed, groupLabel, groupOf, statusLabel, toneOf } from "./status";

export function OrderToolbar({ q, setQ, orders, filter, setFilter }) {
  const counts = orders.reduce((m, o) => ({ ...m, [groupOf(o)]: (m[groupOf(o)] || 0) + 1 }), {});
  return (
    <div className="card-surface flex flex-wrap items-center gap-3 p-3" data-testid="orders-toolbar">
      <label className="flex h-11 w-full items-center gap-2 rounded-md border bg-background px-3 sm:w-80">
        <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquise por cliente ou número do pedido" className="h-full min-w-0 flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground" data-testid="orders-search-input" />
      </label>
      <div className="flex flex-wrap gap-2">
        {GROUPS.filter((g) => counts[g]).map((g) => (
          <button key={g} type="button" onClick={() => setFilter(filter === g ? "" : g)} title={filter === g ? "Mostrar pedidos em aberto" : `Mostrar só: ${groupLabel(g)}`}
            className={cn("flex items-center gap-2 rounded-md px-2.5 py-1.5 text-xs font-medium transition-shadow", TONE[g][1], filter === g && "ring-2 ring-primary")} data-testid={`orders-filter-${g}`}>
            <span className="font-mono font-bold">{counts[g]}</span>{groupLabel(g)}
          </button>
        ))}
      </div>
    </div>
  );
}

function OrderRow({ o, active, onSelect }) {
  const [Icon] = TYPE[o.type] || TYPE.delivery;
  const [border, badge] = toneOf(o);
  return (
    <button type="button" onClick={() => onSelect(o.id)} data-testid={`order-card-${o.number}`}
      className={cn("flex w-full items-center gap-3 border-b border-l-4 px-4 py-3 text-left transition-colors", border, active ? "bg-muted" : "hover:bg-muted/50")}>
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-muted-foreground/15 text-muted-foreground"><Icon className="h-5 w-5" /></span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium">{o.customer.name} <span className="text-xs font-normal text-muted-foreground">#{o.number}</span></span>
        <span className="text-sm text-muted-foreground">{brl(o.total)}</span>
      </span>
      <span className="flex shrink-0 flex-col items-end gap-1.5">
        <span className="text-xs text-muted-foreground">{elapsed(o.created_at)}</span>
        <span className={cn("rounded px-2 py-0.5 text-[11px] font-medium", badge, o.status === "recebido" && "animate-pulse")} data-testid={`order-status-${o.number}`}>{statusLabel(o)}</span>
      </span>
    </button>
  );
}

export function OrderList({ list, selected, onSelect, filtered }) {
  return (
    <section className="card-surface min-h-[320px] overflow-hidden lg:min-h-0 lg:overflow-y-auto" data-testid="order-list">
      {list.length ? list.map((o) => <OrderRow key={o.id} o={o} active={o.id === selected} onSelect={onSelect} />)
        : <p className="grid h-full min-h-[320px] place-items-center px-6 text-center text-muted-foreground" data-testid="order-list-empty">{filtered ? "Nenhum pedido encontrado" : "Seus pedidos aparecerão aqui"}</p>}
    </section>
  );
}
